// extracted by mini-css-extract-plugin
export default {"root":"IconBadge_root__H5Twh","badge":"IconBadge_badge__U1vkq","colorError":"IconBadge_colorError__wIuZk"};